import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setCargoConsultaVerbasIndenizatorias: ['cargo'],
    setReferenciaConsultaVerbasIndenizatorias: ['referencia'],
    limpaFiltroConsultaVerbasIndenizatorias: [],
    receberFiltroConsultaVerbasIndenizatorias: ['filtroRecebido'],
    setStatusConsultaVerbasIndenizatorias: ['status'],
})

const mes = String(new Date().getMonth() + 1).padStart(2, '0')
const ano = new Date().getFullYear()

const INITIAL_STATE = {
    referencia: mes + '/' + ano,
    cargo: '',
    status: { label: '', value: '' },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: action.referencia }
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_VERBAS_INDENIZATORIAS]: setReferencia,
    [Types.SET_CARGO_CONSULTA_VERBAS_INDENIZATORIAS]: setCargo,
    [Types.LIMPA_FILTRO_CONSULTA_VERBAS_INDENIZATORIAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_VERBAS_INDENIZATORIAS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_VERBAS_INDENIZATORIAS]: setStatus,
})
